import { render, staticRenderFns } from "./bbs-watchlist.vue?vue&type=template&id=7d33cb27&scoped=true&"
import script from "./bbs-watchlist.vue?vue&type=script&lang=js&"
export * from "./bbs-watchlist.vue?vue&type=script&lang=js&"
import style0 from "./bbs-watchlist.vue?vue&type=style&index=0&id=7d33cb27&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d33cb27",
  null
  
)

export default component.exports